export class VehRemPrinted {
  nombre: string | null;
  fecha: Date | null;
  tamano: string;
  impresoras: string;
  isInvalid: boolean;

  /**
   * Adapted from ReportRemito.ts - see comment there for explanation
   * @param data The data received from HttpClient.
   */
  static transformData(data: any): VehRemPrinted {
    let vehRemPrintData = new VehRemPrinted();
    vehRemPrintData.nombre = data.pdfName;
    vehRemPrintData.fecha = data.fecCreacion != null ? new Date(data.fecCreacion) : null;
    vehRemPrintData.tamano = data.size;
    //vehRemPrintData.impresoras = data.distributionGroupCod;

    return vehRemPrintData;
  }
}
